var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", staticStyle: { width: "fit-content" } },
    [
      _c(
        "div",
        { staticClass: "section" },
        [
          _vm.isFba
            ? _c(
                "el-form",
                {
                  staticClass: "section",
                  staticStyle: { "flex-direction": "row" },
                  attrs: { disabled: _vm.readonly }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        width: "64px"
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("FbaJob.ValueAddedServices")) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.addedServiceChangeHandler },
                      model: {
                        value: _vm.selectedLocalAddedService,
                        callback: function($$v) {
                          _vm.selectedLocalAddedService = $$v
                        },
                        expression: "selectedLocalAddedService"
                      }
                    },
                    _vm._l(_vm.localAddedService, function(item) {
                      return _c(
                        "el-checkbox",
                        {
                          key: item.code,
                          staticStyle: {
                            "margin-left": "8px",
                            "margin-right": "8px"
                          },
                          attrs: { label: item.code },
                          on: {
                            change: function(val) {
                              return _vm.singleAddedServiceChangeHandler(
                                val,
                                item
                              )
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                      )
                    }),
                    1
                  ),
                  _vm.isBookingNew
                    ? _c(
                        "el-checkbox",
                        {
                          staticStyle: {
                            "margin-left": "8px",
                            "margin-right": "8px"
                          },
                          attrs: { no: "destinationPortService" },
                          model: {
                            value: _vm.form.destinationPortService,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPortService", $$v)
                            },
                            expression: "form.destinationPortService"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.PortOfDestinationServices")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.viewSource === "bookingWorkspace"
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_insurance_toInsure"],
                              expression: "['button_insurance_toInsure']"
                            }
                          ],
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            disabled: _vm.isEdit,
                            no: "toInsure",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.pm.toInsure()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          !_vm.isFba
            ? _c(
                "el-form",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.readonly, no: "booking" },
                      model: {
                        value: _vm.form.booking,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "booking", $$v)
                        },
                        expression: "form.booking"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "customs" },
                      on: {
                        change: function(val) {
                          _vm.form.customsBroker = val
                            ? _vm.form.customsBroker
                            : 0
                          _vm.form.customsDeclarationType = val
                            ? _vm.form.customsDeclarationType
                            : -1
                        }
                      },
                      model: {
                        value: _vm.form.customs,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "customs", $$v)
                        },
                        expression: "form.customs"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "isInsure" },
                      model: {
                        value: _vm.form.insure,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "insure", $$v)
                        },
                        expression: "form.insure"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "comercialInspectation"
                      },
                      model: {
                        value: _vm.form.comercialInspectation,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "comercialInspectation", $$v)
                        },
                        expression: "form.comercialInspectation"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "heating" },
                      model: {
                        value: _vm.form.heating,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "heating", $$v)
                        },
                        expression: "form.heating"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Fumigation")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "itmService" },
                      model: {
                        value: _vm.form.itmService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "itmService", $$v)
                        },
                        expression: "form.itmService"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "headwayTail" },
                      model: {
                        value: _vm.form.headwayTail,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "headwayTail", $$v)
                        },
                        expression: "form.headwayTail"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("RailwayExport.isHeadwayTail")))]
                  ),
                  _vm.isBookingNew && _vm.isFba
                    ? _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-left": "-20px" },
                          attrs: { no: "destinationPortService" },
                          model: {
                            value: _vm.form.destinationPortService,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPortService", $$v)
                            },
                            expression: "form.destinationPortService"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.PortOfDestinationServices")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.viewSource === "bookingWorkspace"
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_insurance_toInsure"],
                              expression: "['button_insurance_toInsure']"
                            }
                          ],
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            disabled: _vm.isEdit,
                            no: "toInsure",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.pm.toInsure()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                      )
                    : _vm._e(),
                  !_vm.isFba
                    ? _c("span", { staticStyle: { "margin-left": "20px" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))
                      ])
                    : _vm._e(),
                  !_vm.isFba
                    ? _c(
                        "el-radio-group",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            disabled:
                              _vm.readonly || Boolean(_vm.form.lclMasterUuid),
                            no: "lob"
                          },
                          on: { change: _vm.lobChangeHandler },
                          model: {
                            value: _vm.form.lob,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "lob", $$v)
                            },
                            expression: "form.lob"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { no: "RE", label: "RE" } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))
                          ]),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { "margin-left": "-20px" },
                              attrs: { no: "RI", label: "RI" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "320px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ConsignInfo")))
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm.form.jobNo,
                          disabled: true,
                          no: "jobNo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isZY
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_AllowSaleProduct,
                                filterable: "",
                                no: "allowSaleProduct",
                                clearable: "",
                                "data-filter-function": function(p) {
                                  if (!p.statusEnabled) {
                                    return false
                                  }
                                  return _vm.isFba
                                    ? p.fbaRailway
                                    : p.railwayFreight
                                },
                                "default-value": _vm.form.saleProductCode || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.saleProductCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_FullOrInside$FULL_OR_INSIDE,
                                no: "fullOrInside",
                                clearable: "",
                                "default-value": _vm.form.fullOrInside || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.fullOrInside = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ConsignationCompany")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showWarningImageB,
                                expression: "showWarningImageB"
                              }
                            ],
                            attrs: {
                              content: _vm.warningImageBTip,
                              placement: "right-end"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning red",
                              staticStyle: { cursor: "pointer" }
                            })
                          ]
                        ),
                        !_vm.isFba
                          ? _c("cargo-sales-company-select", {
                              ref: "customerSelect",
                              attrs: {
                                no: "customerId",
                                "method-params": {
                                  customer: true,
                                  active: true,
                                  companyLob: "railwayExport"
                                },
                                "check-credit": true,
                                "default-value": _vm.form.customerId || "",
                                disabled: !_vm.customerEnabled,
                                job: _vm.form
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.customerIdChange2ContractHandler(p)
                                  _vm.clearPoNo()
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.isFba
                          ? _c("cargo-company-select", {
                              ref: "customerSelect",
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "customerId",
                                "method-params": {
                                  customer: true,
                                  companyLob: "railwayExport",
                                  active: true,
                                  fba: true
                                },
                                "check-credit": true,
                                job: _vm.form,
                                "default-value": _vm.form.customerId || "",
                                disabled: !_vm.customerEnabled,
                                "data-filter-function": _vm.fbaCustomerIdFilter
                              },
                              on: {
                                change: function(p) {
                                  _vm.customerIdChange2ContractHandler(p)
                                  _vm.clearPoNo()
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerProperty") } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.customerTip,
                            placement: "bottom"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customerLevel.level !== "",
                                  expression: "customerLevel.level!==''"
                                }
                              ],
                              staticStyle: { color: "#FD9A14" }
                            },
                            [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                          ),
                          _c("span", { staticStyle: { color: "#D3A73B" } }, [
                            _vm._v(" " + _vm._s(_vm.customerLevel.customerName))
                          ]),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.contractStatusLabel,
                                  expression: "contractStatusLabel"
                                }
                              ],
                              staticClass: "red"
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.contractStatusLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.advancePaymentLabel,
                                  expression: "advancePaymentLabel"
                                }
                              ],
                              staticStyle: { color: "brown" }
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.advancePaymentLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.stampPictureView.businessDocuments
                                      .length > 0,
                                  expression:
                                    "stampPictureView.businessDocuments.length > 0"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  _vm.stampPictureView.visible = true
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { "text-align": "right" },
                                attrs: {
                                  title: _vm.$t("Message.BookingSeal"),
                                  src: _vm.stampIcon,
                                  height: "14"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContactPerson") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "customerContact",
                                filterable: "",
                                "allow-create": true
                              },
                              model: {
                                value: _vm.form.customerContact,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "customerContact", $$v)
                                },
                                expression: "form.customerContact"
                              }
                            },
                            _vm._l(_vm.contactList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.contactPerson,
                                  value: item.contactPerson
                                }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-link",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowContactPersonDetail,
                                  expression: "!isShowContactPersonDetail"
                                }
                              ],
                              class: _vm.form.customerContact
                                ? ""
                                : "not-click",
                              attrs: { no: "Detail" },
                              on: { click: _vm.showContactDialog }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.containerLoadType")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: !_vm.lclslaveEnabled,
                            no: "containerLoadType"
                          },
                          on: {
                            change: function(val) {
                              _vm.pm.containerLoadTypeChange(val)
                            }
                          },
                          model: {
                            value: _vm.form.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "containerLoadType", $$v)
                            },
                            expression: "form.containerLoadType"
                          }
                        },
                        _vm._l(_vm.containerLoadTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "" },
                          on: { change: _vm.onCargoTypeChagne },
                          model: {
                            value: _vm.form.cargoType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoType", $$v)
                            },
                            expression: "form.cargoType"
                          }
                        },
                        _vm._l(_vm.cargoType4JobSelect, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.transportType")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "transportType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportationType,
                          "method-params": {
                            companyLob: "railwayExport",
                            transportType: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.transportType,
                          "tag-name":
                            this.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName",
                          "tag-value": "code",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transportType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("RailwayExport.fullHalf")) + " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "fullHalf",
                          "select-type":
                            _vm.selectTypeNames.local_cache_FullHalf,
                          filterable: "",
                          "default-value": _vm.form.fullHalf,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.fullHalf = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.transportLine")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "transportLine",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayLine,
                          filterable: "",
                          "default-value": _vm.form.transportLine,
                          placeholder: _vm.$t("SeaExport.RequiredItem"),
                          "tag-name": "name"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transportLine = p.value
                            _vm.pm.refreshPlanner(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("RailwayExport.ETD2")) + " ")]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticClass: "departure-date-picker",
                          staticStyle: {
                            flex: "1",
                            width: "140px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "etd",
                            value: _vm.form.etd,
                            disabled:
                              _vm.form.uuid && _vm.form.lclMasterUuid
                                ? true
                                : !_vm.etdEnabled ||
                                  (_vm.provisionEtdLocked &&
                                    _vm.form.lob === "RE"),
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.etdChange }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.sailingDay))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm.provisionEtdLocked && _vm.form.lob === "RE"
                      ? _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-size": "12px" }
                          },
                          [_vm._v("(已计提校准不可修改)")]
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.ETA2") } },
                    [
                      _vm.form.lob === "RI"
                        ? _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("RailwayExport.ETA2")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: {
                              flex: "1",
                              width: "140px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled:
                                !_vm.lclslaveEnabled ||
                                (_vm.provisionEtdLocked &&
                                  _vm.form.lob === "RI"),
                              no: "eta",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.etaChange },
                            model: {
                              value: _vm.form.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "eta", $$v)
                              },
                              expression: "form.eta"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.etaSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _vm.provisionEtdLocked && _vm.form.lob === "RI"
                        ? _c(
                            "span",
                            {
                              staticStyle: { color: "red", "font-size": "12px" }
                            },
                            [_vm._v("(已计提校准不可修改)")]
                          )
                        : _vm._e()
                    ]
                  ),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("RailwayExport.ATD2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "140px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            disabled: !_vm.lclslaveEnabled,
                            no: "atd",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          on: { input: _vm.atdChange },
                          model: {
                            value: _vm.form.atd,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "atd", $$v)
                            },
                            expression: "form.atd"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.atdSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("RailwayExport.ATA2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "140px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            disabled: !_vm.lclslaveEnabled,
                            no: "ata",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          on: { input: _vm.ataChange },
                          model: {
                            value: _vm.form.ata,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ata", $$v)
                            },
                            expression: "form.ata"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.ataSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customsDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customsDate", $$v)
                          },
                          expression: "form.customsDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("RailwayExport.departureStation")) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            disabled: !_vm.lclslaveEnabled,
                            no: "departureStation",
                            "select-type":
                              _vm.selectTypeNames.basic_data_RailwayStation,
                            filterable: "",
                            "default-value": _vm.form.departureStation,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { parentCallBack: _vm.departureStationChange }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              width: "80px",
                              "padding-left": "5px"
                            },
                            attrs: {
                              disabled: !_vm.lclslaveEnabled,
                              no: "transfer"
                            },
                            model: {
                              value: _vm.form.transfer,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transfer", $$v)
                              },
                              expression: "form.transfer"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.transfer,
                          expression: "form.transfer"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.transferStation")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "transferStation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.form.transferStation
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transferStation = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.transitStation")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "transitStation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.form.transitStation,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transitStation = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("RailwayExport.destinationStation")
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationStation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.form.destinationStation,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { parentCallBack: _vm.destinationStationChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationCountry")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationCountry",
                          "select-type": _vm.selectTypeNames.basic_data_Country,
                          filterable: "",
                          "default-value": _vm.form.destinationCountry
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.destinationCountry = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SolicitationType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: !_vm.cargoSourceEnabled,
                            no: "cargoSource",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          on: {
                            change: function($event) {
                              _vm.form.designationAgent = 0
                              _vm.pm.cargoSourceChange({
                                fieldName: "cargoSource"
                              })
                            }
                          },
                          model: {
                            value: _vm.form.cargoSource,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoSource", $$v)
                            },
                            expression: "form.cargoSource"
                          }
                        },
                        _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                    [
                      _vm.form.lob === "RE"
                        ? _c("cargo-advance-select", {
                            key: "1",
                            ref: "customJobType",
                            attrs: {
                              no: "customJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              "method-params": { type: _vm.form.lob },
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.customJobTypeList,
                              "default-value": _vm.form.customJobType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customJobType = p.value
                                _vm.onCustomJobTypeChange()
                                _vm.contractRuleFieldChange(
                                  _vm.form.customerId,
                                  _vm.form.designationAgent
                                )
                              }
                            }
                          })
                        : _vm.form.lob === "RI"
                        ? _c("cargo-advance-select", {
                            key: "2",
                            ref: "customJobType",
                            attrs: {
                              no: "customJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.customJobTypeList,
                              "method-params": { type: _vm.form.lob },
                              "default-value": _vm.form.customJobType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customJobType = p.value
                                _vm.onCustomJobTypeChange()
                                _vm.contractRuleFieldChange(
                                  _vm.form.customerId,
                                  _vm.form.designationAgent
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.form.customJobType &&
                  _vm.secondaryCustomJobTypeList.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "secondaryCustomJobType",
                            attrs: {
                              no: "secondaryCustomJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              cache: false,
                              "default-value": _vm.form.secondaryCustomJobType,
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.secondaryCustomJobTypeList
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.secondaryCustomJobType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "bookingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            companyLob: "railwayExport",
                            bookingAgent: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.bookingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.bookingAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.portAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "portAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            companyLob: "railwayExport",
                            portAgent: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.portAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.portAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("RailwayExport.forwardingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "forwardingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            companyLob: "railwayExport",
                            forwardingAgent: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.forwardingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.forwardingAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("queryJob.destinationAgent") } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.destinationAgentTip,
                            disabled: !_vm.showDestinationAgentWarning,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            ref: "destinationAgent",
                            attrs: {
                              no: "destinationAgent",
                              disabled: !_vm.lclslaveEnabled,
                              "method-params": {
                                overseaAgent: true,
                                active: true,
                                companyLob: "railwayExport"
                              },
                              "check-credit": true,
                              job: _vm.form,
                              "default-value": _vm.form.destinationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.txtDestinationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.cargoSource === "NC",
                          expression: "form.cargoSource==='NC'"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.NominatedAgent") }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageA,
                                  expression: "showWarningImageA"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageATip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning red",
                                staticStyle: { cursor: "pointer" }
                              })
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "designationAgent",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              disabled: !_vm.designationAgentEnabled,
                              "method-params": {
                                designationAgent: true,
                                active: true
                              },
                              "check-credit": true,
                              "default-value": _vm.form.designationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.designationAgentChangeHandler(p)
                              }
                            }
                          }),
                          _vm.overseaAgentDataProviderChange
                            ? _c("cargo-advance-select", {
                                attrs: {
                                  no: "designationAgent2",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  cache: false,
                                  disabled: !_vm.designationAgentEnabled,
                                  "check-credit": true,
                                  "default-value":
                                    _vm.form.designationAgent || "",
                                  filterable: "",
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "tag-name": "englishName",
                                  "static-options": _vm.pm.designationAgentArray
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.designationAgentChangeHandler(p)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TransportSource") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportSource,
                          no: "transportSource",
                          "default-value": _vm.form.transportSource,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.transportSource = item.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ServiceStatisticalArea")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_StatisticArea,
                          no: "statisticArea",
                          "default-value": _vm.form.statisticArea,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.statisticArea = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.AdditionalInformation")))
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.LocalService") } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "warehousing" },
                          on: {
                            change: function($event) {
                              return _vm.pm.loadingTermChange("warehousing")
                            }
                          },
                          model: {
                            value: _vm.form.warehousing,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehousing", $$v)
                            },
                            expression: "form.warehousing"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.WarehouseLoadingStorage"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "landTransportation" },
                          on: {
                            change: function($event) {
                              return _vm.pm.loadingTermChange(
                                "landTransportation"
                              )
                            }
                          },
                          model: {
                            value: _vm.form.landTransportation,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "landTransportation", $$v)
                            },
                            expression: "form.landTransportation"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.DoorLoadingDelivery"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "selfDeliver" },
                          model: {
                            value: _vm.form.selfDeliver,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "selfDeliver", $$v)
                            },
                            expression: "form.selfDeliver"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.NotResponsibleForTruckingAndLoading"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  !_vm.isFba &&
                  _vm.isBookingNew &&
                  _vm.form.destinationPortService
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "dischargingPortDoor" },
                              model: {
                                value: _vm.form.dischargingPortDoor,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "dischargingPortDoor", $$v)
                                },
                                expression: "form.dischargingPortDoor"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.DispatchVehiclesAtDestination"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "usCustomsClearance" },
                              model: {
                                value: _vm.form.usCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "usCustomsClearance", $$v)
                                },
                                expression: "form.usCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.UsCustomsClearance")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba &&
                  _vm.isBookingNew &&
                  _vm.form.destinationPortService
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.addedServiceChangeHandler },
                              model: {
                                value: _vm.selectedPodAddedService,
                                callback: function($$v) {
                                  _vm.selectedPodAddedService = $$v
                                },
                                expression: "selectedPodAddedService"
                              }
                            },
                            _vm._l(_vm.podAddedService, function(item) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: item.code,
                                  staticStyle: { display: "block" },
                                  attrs: { label: item.code },
                                  on: {
                                    change: function(val) {
                                      return _vm.singleAddedServiceChangeHandler(
                                        val,
                                        item
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WarehouseNo") } },
                    [
                      _c("el-input", {
                        staticStyle: { "margin-bottom": "10px" },
                        attrs: { no: "warehouseNo" },
                        model: {
                          value: _vm.form.warehouseNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "warehouseNo", $$v)
                          },
                          expression: "form.warehouseNo"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "padding-left": "13px",
                            "padding-right": "13px"
                          },
                          attrs: {
                            disabled: true,
                            no: "ObtainTheWarehouseNo",
                            type: "primary"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.ObtainTheWarehouseNo"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.paymentMethod")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentMethod",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentMethod,
                          "method-params": {
                            companyLob: "railwayExport",
                            paymentMethod: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.paymentMethod,
                          "tag-name":
                            this.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName",
                          "tag-value": "code",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.paymentMethod = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.mbl") } },
                    [
                      _c("el-input", {
                        attrs: { no: "mbl" },
                        model: {
                          value: _vm.form.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mbl", $$v)
                          },
                          expression: "form.mbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.vessel") } },
                    [
                      _c("el-input", {
                        attrs: { no: "vessel" },
                        model: {
                          value: _vm.form.vessel,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "vessel", $$v)
                          },
                          expression: "form.vessel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.voyageFlight") } },
                    [
                      _c("el-input", {
                        attrs: { no: "voyageFlight" },
                        model: {
                          value: _vm.form.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "voyageFlight", $$v)
                          },
                          expression: "form.voyageFlight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.MasterBusinessNo") } },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm.form.lclMaster
                            ? _vm.form.lclMaster.jobNo
                            : "",
                          disabled: true,
                          no: "MblNo3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.BusinessReferenceNo") }
                    },
                    [
                      _c("cargo-input", {
                        attrs: { no: "customerRefNo", trim: true },
                        model: {
                          value: _vm.form.customerRefNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerRefNo", $$v)
                          },
                          expression: "form.customerRefNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      class: _vm.poNoRed ? "poNoClass" : "",
                      attrs: { label: _vm.$t("SeaExport.ItemNo") }
                    },
                    [
                      !_vm.openProjectConfig
                        ? _c("el-input", {
                            attrs: { no: "poNo" },
                            model: {
                              value: _vm.form.poNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "poNo", $$v)
                              },
                              expression: "form.poNo"
                            }
                          })
                        : _vm._e(),
                      _vm.openProjectConfig
                        ? _c("cargo-project-select", {
                            attrs: {
                              no: "poNo",
                              "default-value": _vm.form.poNo,
                              "customer-id": _vm.form.customerId,
                              "is-linked": _vm.isProjectLinkedCustomer
                            },
                            on: {
                              change: function(p) {
                                _vm.form.poNo = p.value
                                _vm.form.projectName = p.projectName
                                _vm.changeProject()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ProjectName") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.projectName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "projectName", $$v)
                              },
                              expression: "form.projectName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ProjectBatch") } },
                        [
                          _c("el-input", {
                            attrs: { no: "projectBatch" },
                            model: {
                              value: _vm.form.projectBatch,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "projectBatch", $$v)
                              },
                              expression: "form.projectBatch"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomsBroker") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.customsBrokerEnabled,
                          no: "customsBroker",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "data-filter-function": _vm.customsBrokerFilter,
                          filterable: "",
                          "method-params": { customsBroker: true },
                          "default-value": _vm.form.customsBroker || "",
                          placeholder: _vm.form.customs
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t(
                                "SeaExport.PleaseTickCustomsDeclarationOption"
                              )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.customsBrokerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationMethod")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethod",
                              disabled: !_vm.customsBrokerEnabled,
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 2 },
                              "tag-value": "serialNum",
                              filterable: "",
                              "default-value": _vm.form.customClaim
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customClaim = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationType")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsDeclarationType",
                          disabled: !_vm.customsBrokerEnabled,
                          "select-type":
                            _vm.selectTypeNames
                              .basic_data_CustomsDeclarationType,
                          filterable: "",
                          "default-value":
                            _vm.form.customsDeclarationType === -1
                              ? ""
                              : _vm.form.customsDeclarationType,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "tradeTerm",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.form.tradeTerm,
                          "callback-params": { key: "tradeTerm" }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.tradeTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "incoTerm",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.form.incoTerm,
                          "callback-params": { key: "incoTerm" },
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HaulageCompany") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.form.landTransportation,
                          no: "carryingCmp",
                          "method-params": { truckCmp: true, active: true },
                          "default-value": _vm.form.carryingCmp || "",
                          placeholder: _vm.form.landTransportation
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              )
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.carryingCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Information.TransportationTerms")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "freightTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.freightTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.freightTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.isFba
                          ? _vm.$t("RailwayExport.DomesticWarehouse")
                          : _vm.openWarehouse
                          ? _vm.$t("SeaExport.WarehouseSupplier")
                          : _vm.$t("SeaExport.Warehouse")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.warehouseEabled,
                          no: "warehouseCmp",
                          "method-params": { warehouse: true, active: true },
                          "default-value": _vm.isFba
                            ? Number(_vm.fbaJob.domesticWarehouse) || ""
                            : _vm.form.warehouseCmp || "",
                          placeholder: _vm.form.warehousing
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("SeaExport.PleaseSelectWarehouse")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.warehouseCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.openWarehouse && !_vm.isFba
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.WareHouseName") } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "warehouseName",
                              attrs: {
                                no: "warehouseName",
                                disabled:
                                  !_vm.warehouseEabled ||
                                  !_vm.form.warehouseCmp,
                                "allow-create": true,
                                filterable: "",
                                clearable: true
                              },
                              on: { change: _vm.warehouseNameChangeHandler },
                              model: {
                                value: _vm.form.warehouseName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "warehouseName", $$v)
                                },
                                expression: "form.warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("RailwayExport.OverseasWarehouse")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "overseaWarehouseCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_OverseaWarehouse,
                              filterable: "",
                              "method-params": { ifFba: false },
                              clearable: false,
                              "tag-name": "countryChineseName",
                              "tag-value": "warehouseCode",
                              "default-value": _vm.form.overseaWarehouseCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.overseaWarehouseCode = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "blue",
                      attrs: { no: "diffPlacesCollaborate" },
                      model: {
                        value: _vm.form.diffPlacesCollaborate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "diffPlacesCollaborate", $$v)
                        },
                        expression: "form.diffPlacesCollaborate"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("RailwayExport.isDiffPlacesCollaborate"))
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.loadingPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "loadingPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            loadingPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.loadingPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.loadingPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.signBillPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "signBillPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            signBillPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.signBillPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.signBillPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "blue",
                      attrs: {
                        disabled: !_vm.lclslaveEnabled,
                        no: "fullShipment"
                      },
                      model: {
                        value: _vm.form.fullShipment,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fullShipment", $$v)
                        },
                        expression: "form.fullShipment"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("RailwayExport.isFullShipment")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.dischargePortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "dischargePortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            dischargePortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.dischargePortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dischargePortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationPortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "destinationPortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            destinationPortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.destinationPortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.destinationPortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BoxOneWay") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "boxOneWay" },
                          model: {
                            value: _vm.form.boxOneWay,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "boxOneWay", $$v)
                            },
                            expression: "form.boxOneWay"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: 0
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_OneWay"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Circulation"),
                              value: 2
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
                  ]),
                  _vm.form.containerLoadType === "FCL" ||
                  _vm.form.containerLoadType === "BB"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-sea-eq-data-grid", {
                            ref: "bookingSeaEqDataGrid",
                            attrs: {
                              value: _vm.seaEqList,
                              "container-load-type": _vm.form.containerLoadType,
                              "hide-soc": true,
                              "is-edit": _vm.isEdit,
                              job: _vm.form
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.containerLoadType === "BULK"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-bulk-data-grid", {
                            attrs: {
                              value: _vm.cargoBulkDetailList,
                              "job-uuid": _vm.form.uuid,
                              "is-edit": _vm.isEdit
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.containerLoadType === "SPA"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-special-data-grid", {
                            attrs: {
                              value: _vm.seaEqList,
                              "hide-eq-type": true,
                              "hide-soc": true,
                              "is-edit": _vm.isEdit,
                              job: _vm.form
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.QuantityConsignActual")
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "quantityContract",
                              precision: 0,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.jobContractQwcChange(1)
                                _vm.calcEstVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.form.quantityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityContract", $$v)
                              },
                              expression: "form.quantityContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "quantityActual",
                            attrs: {
                              disabled: _vm.pm.billChargeFlag,
                              no: "quantityActual",
                              precision: 0,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.SEUtils.changeQWCRule(null, function() {
                                  _vm.form.quantityContract =
                                    _vm.form.quantityActual
                                })
                                _vm.pm.changeSynBillOfLadingQWC()
                                _vm.pm.refContainerUsageQwc(2)
                                _vm.quantityActualChange()
                              }
                            },
                            model: {
                              value: _vm.form.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityActual", $$v)
                              },
                              expression: "form.quantityActual"
                            }
                          }),
                          _c("span", { staticStyle: { width: "65px" } }, [
                            _vm._v("PCS")
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.WeightConsignActual") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "weightContract",
                              precision: 3,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.weightContractChange()
                                _vm.calcEstVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.form.weightContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightContract", $$v)
                              },
                              expression: "form.weightContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "weightActual",
                            attrs: {
                              no: "weightActual",
                              precision: 3,
                              min: 0,
                              disabled: _vm.pm.billChargeFlag
                            },
                            on: { change: _vm.weightActualChange },
                            model: {
                              value: _vm.form.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightActual", $$v)
                              },
                              expression: "form.weightActual"
                            }
                          }),
                          _c("span", { staticStyle: { width: "65px" } }, [
                            _vm._v("KGS")
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.CubageConsignActual") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "cubageContract",
                              precision: 3,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.cubageContractChange()
                                _vm.calcEstVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.form.cubageContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageContract", $$v)
                              },
                              expression: "form.cubageContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "cubageActual",
                            attrs: {
                              no: "cubageActual",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.cubageActualEnabled
                            },
                            on: { change: _vm.cubageActualChange },
                            model: {
                              value: _vm.form.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageActual", $$v)
                              },
                              expression: "form.cubageActual"
                            }
                          }),
                          _c("span", { staticStyle: { width: "65px" } }, [
                            _vm._v("CBM")
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.VolumetricWeightConsignActual"
                            )
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "volumetricWeightContract",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calcEstVolumetricAndChargeWeight(
                                      _vm.form.volumetricWeightContract
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.volumetricWeightContract,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "volumetricWeightContract",
                                      $$v
                                    )
                                  },
                                  expression: "form.volumetricWeightContract"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { padding: "0 2px" } },
                                [_vm._v("/")]
                              ),
                              _c("auto-number-input", {
                                ref: "volumetricWeight",
                                attrs: {
                                  no: "volumetricWeight",
                                  precision: 3,
                                  min: 0
                                },
                                on: { change: _vm.changeVolumetricWeight },
                                model: {
                                  value: _vm.form.volumetricWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "volumetricWeight", $$v)
                                  },
                                  expression: "form.volumetricWeight"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ChargeWeightConsignActual")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "chargeWeightContract",
                                  precision: 3,
                                  min: 0
                                },
                                model: {
                                  value: _vm.form.chargeWeightContract,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "chargeWeightContract",
                                      $$v
                                    )
                                  },
                                  expression: "form.chargeWeightContract"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { padding: "0 2px" } },
                                [_vm._v("/")]
                              ),
                              _c("auto-number-input", {
                                ref: "chargeWeight",
                                attrs: {
                                  no: "chargeWeight",
                                  precision: 3,
                                  min: 0
                                },
                                on: { change: _vm.changeChargeWeight },
                                model: {
                                  value: _vm.form.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "chargeWeight", $$v)
                                  },
                                  expression: "form.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-around"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: {
                                  "margin-right": "10px",
                                  "margin-left": "20px"
                                },
                                model: {
                                  value: _vm.fbaJob.electric,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "electric", $$v)
                                  },
                                  expression: "fbaJob.electric"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("RailwayExport.WithBattery"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.magnetic,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "magnetic", $$v)
                                  },
                                  expression: "fbaJob.magnetic"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("RailwayExport.WithMagnet"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.powdery,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "powdery", $$v)
                                  },
                                  expression: "fbaJob.powdery"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("RailwayExport.Powder")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.liquid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "liquid", $$v)
                                  },
                                  expression: "fbaJob.liquid"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("RailwayExport.Liquid")))]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.containerLoadType === "BULK",
                          expression: "form.containerLoadType==='BULK'"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.QuantitySize") }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "insideQuantitySize",
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.form.insideQuantitySize,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "insideQuantitySize", $$v)
                          },
                          expression: "form.insideQuantitySize"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "packing",
                          "default-value": _vm.form.packing
                        },
                        on: {
                          change: function(p) {
                            _vm.form.packing = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                              )
                            )
                          ]),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: {
                                no: "SelectCargoChineseName",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showHsCodeSearchDialog(
                                    _vm.$t("Message.SelectCargoChineseName"),
                                    function(p) {
                                      _vm.form.cargoChineseName =
                                        p.commodityName
                                    }
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Search")))]
                          )
                        ],
                        1
                      ),
                      _c("cargo-rich-textarea", {
                        class:
                          _vm.form.cargoChineseNameWarning === 1
                            ? "red-border"
                            : "",
                        staticStyle: { height: "110px" },
                        attrs: {
                          no: "cargoChineseName",
                          disabled: _vm.readonly,
                          "text-chars": 0
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.form.cargoChineseName,
                              false,
                              function(val) {
                                _vm.form.cargoChineseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoChineseName", $$v)
                          },
                          expression: "form.cargoChineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        class:
                          _vm.form.cargoEnglishNameWarning === 1
                            ? "red-border"
                            : "",
                        staticStyle: { height: "110px" },
                        attrs: {
                          no: "cargoEnglishName",
                          "show-count": true,
                          disabled: _vm.readonly,
                          "auto-uppercase": _vm.isUppercaseByConfig,
                          "text-chars": 0
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                              _vm.form.cargoEnglishName,
                              _vm.isUppercaseByConfig,
                              function(val) {
                                _vm.form.cargoEnglishName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoEnglishName", $$v)
                          },
                          expression: "form.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Marks") } },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          disabled: _vm.readonly,
                          no: "mark",
                          "show-count": true,
                          "text-chars": 0,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Marks"),
                              _vm.form.mark,
                              _vm.isUppercaseByConfig,
                              function(val) {
                                _vm.form.mark = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.mark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mark", $$v)
                          },
                          expression: "form.mark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.OperationInfo")))
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("SeaExport.SalesCompany")) + " "
                          )
                        ]
                      ),
                      _c("el-input", {
                        attrs: {
                          value: _vm.txtSalesOffice,
                          disabled: true,
                          no: "txtSalesOffice"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("SeaExport.Sales")) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "sales",
                          staticStyle: { flex: "1" },
                          attrs: {
                            disabled: !_vm.saleEnabled,
                            no: "salesRecord",
                            "method-params": {
                              officeId: _vm.salesOfficeCheck
                                ? _vm.$store.getters.currentOfficeId
                                : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.form.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: _vm.salesPrompt,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.form.salesRecord = p.value
                              _vm.pm.salesChangeHandler(p)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: { no: "provisioned", disabled: true },
                            model: {
                              value: _vm.form.provisioned,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "provisioned", $$v)
                              },
                              expression: "form.provisioned"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.form.cargoSalesId || "",
                          "merge-load": true,
                          "static-options": _vm.cargoSalesList
                        },
                        on: {
                          change: function(p) {
                            _vm.form.cargoSalesId = p.value
                            _vm.pm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.SalesDepartment")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-department-new-select", {
                        attrs: {
                          disabled: !_vm.form.sales,
                          no: "salesDepartment",
                          enables: true,
                          "sales-id": Number(_vm.form.sales),
                          "office-id": _vm.form.salesOffice,
                          "department-id": Number(_vm.form.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.salesDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          disabled:
                            (!_vm.isRegionalCommission &&
                              _vm.pm.isEntrustOrder(true)) ||
                            _vm.opOfficeDisabled,
                          "is-regional-commission": _vm.isRegionalCommission,
                          no: "opOffice",
                          "office-id": Number(_vm.form.opOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opOffice = p.value
                            _vm.form.opDepartment = 0
                            _vm.opOfficeChargeHandler()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.OperationDepartment")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        attrs: {
                          disabled: _vm.pm.isWithinCloseAccountDate,
                          no: "opDepartment",
                          enables: true,
                          "office-id": Number(_vm.form.opOffice),
                          "department-id": Number(_vm.form.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("SeaExport.Operation")) + " "
                          )
                        ]
                      ),
                      _c("cargo-user-select", {
                        attrs: {
                          disabled: !_vm.opEabled,
                          no: "op",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.form.op || "",
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.op
                        },
                        on: {
                          change: function(p) {
                            _vm.form.op = p.value
                            _vm.pm.txtOPChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrOffice = p.value
                            _vm.form.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("Message.Customer_Service")))
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.form.csrOffice),
                          enables: true,
                          "department-id": Number(_vm.form.csrDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                    [
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          no: "csr",
                          "method-params": {
                            officeId:
                              _vm.pm.isEntrustOrder ||
                              _vm.form.salesOffice === 1
                                ? _vm.form.opOffice
                                : _vm.form.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.form.csr || "",
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.csr
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.form.siteOP || "",
                          "static-options": _vm.userPortRoleData.siteOp
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.siteOpChangeHandler(_vm.form, p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OverseaCustomerService")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "overseaOp",
                        attrs: {
                          no: "overseaOp",
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "default-value": _vm.form.overseaOp || "",
                          "static-options": _vm.isHC
                            ? null
                            : _vm.userPortRoleData.overseaOp ||
                              _vm.overseaAgentUsersList,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.form.overseaOp = p.value
                            _vm.pm.overseaOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcOffice = p.value
                            _vm.form.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Message.Documentation_Department"))
                        )
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.form.dcOffice),
                          enables: true,
                          "department-id": Number(_vm.form.dcDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-user-select", {
                        ref: "dc",
                        attrs: {
                          no: "dc",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.form.dc || "",
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.doc
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.plannerOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerOffice = p.value
                            _vm.form.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("RailwayExport.plannerDepartment"))
                        )
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.form.plannerOffice),
                          enables: true,
                          "department-id": Number(_vm.form.plannerDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.planner") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "planner",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "railwayLine"
                          },
                          "default-value": _vm.form.planner || "",
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.railwayLine
                        },
                        on: {
                          change: function(p) {
                            _vm.form.planner = p.value
                            _vm.pm.txtPlannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.form.userDefinedRoleId1 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole1
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.form.userDefinedRoleId2 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole2
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c("special-requests-grid", {
                        ref: "selectedSpecialRequest",
                        attrs: {
                          "is-edit": _vm.isEdit,
                          "customer-id": _vm.form.customerId,
                          lob: _vm.form.lob,
                          job: _vm.form
                        },
                        model: {
                          value: _vm.form.satisfiedRequests,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "satisfiedRequests", $$v)
                          },
                          expression: "form.satisfiedRequests"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OperationRequirements")
                      }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.form.operationContent,
                            placement: "left"
                          }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.form.operationContent
                                  ? _vm.form.operationContent.replace(
                                      /[\n]/g,
                                      "</br>"
                                    )
                                  : _vm.$t("SeaExport.NoData")
                              )
                            },
                            slot: "content"
                          }),
                          _c("el-input", {
                            attrs: {
                              value: _vm.form.operationContent,
                              no: "operationContent",
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t(
                                    "SeaExport.DoubleClickToAddOperationRequirements"
                                  ),
                              type: "textarea",
                              rows: 4
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.selectOperationReqDialog.value =
                                  _vm.form.operationContent
                                _vm.selectOperationReqDialog.visible =
                                  _vm.isEdit
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationTips") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "operationTips",
                          type: "textarea",
                          rows: 4
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.OperationTips"),
                              _vm.form.operationTips,
                              false,
                              function(val) {
                                _vm.form.operationTips = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.operationTips,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "operationTips", $$v)
                          },
                          expression: "form.operationTips"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ExtraChargeClause") } },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm.txtSurchargeTerms,
                          no: "txtSurchargeTerms",
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t(
                                "SeaExport.DoubleClickToAddExtraChargeClause"
                              ),
                          type: "textarea",
                          rows: 4
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.selectSurchargeTermsDialog.rowData =
                              _vm.form.surchargeTerms
                            _vm.selectSurchargeTermsDialog.visible = true
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WarehousingInfo") } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: true,
                          no: "txtWhs",
                          type: "textarea",
                          rows: 4,
                          value: _vm.txtWhs
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks", type: "textarea", rows: 4 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.form.remarks,
                              false,
                              function(val) {
                                _vm.form.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarks", $$v)
                          },
                          expression: "form.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.isFba
            ? _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "120px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s("FBA"))
                      ]),
                      !_vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("RailwayExport.ServiceChannel")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "serviceChannel",
                                  disabled: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_FbaChannel,
                                  filterable: "",
                                  "method-params": {
                                    shippingType: _vm.fbaJob.shippingType,
                                    active: true
                                  },
                                  clearable: true,
                                  "default-value": _vm.fbaJob.serviceChannel
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.serviceChannel = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("RailwayExport.ServiceChannel")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "", clearable: "" },
                                  on: { change: _vm.changeServiceChannel },
                                  model: {
                                    value: _vm.fbaJob.serviceChannel,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "serviceChannel",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.serviceChannel"
                                  }
                                },
                                _vm._l(_vm.channel4JobSelect, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.channelName,
                                      value: item.channelName
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "RailwayExport.EstimatedStoragegoodReadyTime"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "preWarehousingTime",
                              type: "datetime",
                              clearable: "",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.preWarehousingChangeHandler()
                              }
                            },
                            model: {
                              value: _vm.fbaJob.preWarehousingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "preWarehousingTime", $$v)
                              },
                              expression: "fbaJob.preWarehousingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.ExpectedToEnterAmazonWarehouse"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "preAmazonWhTime",
                              disabled: _vm.readonly,
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.fbaJob.preAmazonWhTime,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "preAmazonWhTime", $$v)
                              },
                              expression: "fbaJob.preAmazonWhTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Destination")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", flex: "1" } },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.fbaJob.warehouseCode,
                                  placement: "bottom-end"
                                }
                              },
                              [
                                _c("el-cascader", {
                                  staticStyle: { "padding-right": "2px" },
                                  attrs: {
                                    options: _vm.destinations,
                                    filterable: "",
                                    clearable: true
                                  },
                                  on: {
                                    focus: function($event) {
                                      return _vm.JobUtils.focusWarehouseCode(
                                        _vm.fbaJob
                                      )
                                    },
                                    blur: function($event) {
                                      return _vm.JobUtils.blurWarehouseCode(
                                        _vm.fbaJob
                                      )
                                    },
                                    change: function(p) {
                                      _vm.JobUtils.warehouseCodeHandler(
                                        _vm.fbaJob,
                                        p
                                      )
                                      _vm.changeWarehouseCode
                                    }
                                  },
                                  model: {
                                    value: _vm.fbaJob.warehouseCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fbaJob, "warehouseCode", $$v)
                                    },
                                    expression: "fbaJob.warehouseCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { no: "remoteWarehouse" },
                                model: {
                                  value: _vm.fbaJob.remoteWarehouse,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "remoteWarehouse", $$v)
                                  },
                                  expression: "fbaJob.remoteWarehouse"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("RailwayExport.RemoteWarehouse")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Warehouse.DestinationCountry")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "country" },
                            model: {
                              value: _vm.fbaJob.country,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "country", $$v)
                              },
                              expression: "fbaJob.country"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("RailwayExport.PostalCode") }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "zipCode" },
                            model: {
                              value: _vm.fbaJob.zipCode,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "zipCode", $$v)
                              },
                              expression: "fbaJob.zipCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.DestinationDeliveryMethod"
                            )
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "destinationDistribution",
                                filterable: ""
                              },
                              on: { change: _vm.destinationDistributionChange },
                              model: {
                                value: _vm.fbaJob.destinationDistribution,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fbaJob,
                                    "destinationDistribution",
                                    $$v
                                  )
                                },
                                expression: "fbaJob.destinationDistribution"
                              }
                            },
                            _vm._l(
                              _vm.FbaJobConstants
                                .ORDER_DESTINATION_DISTRIBUTION_TYPES,
                              function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _vm.fbaJob.destinationDistribution &&
                      Number(_vm.fbaJob.destinationDistribution) === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("RailwayExport.ExpressCompany")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    no: "expressCompany",
                                    placeholder: "",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.fbaJob.expressCompany,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "expressCompany",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.expressCompany"
                                  }
                                },
                                _vm._l(
                                  _vm.FbaJobConstants.EXPRESS_COMPANYS,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.code,
                                      attrs: {
                                        label: item.chineseName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.fbaJob.destinationDistribution &&
                      Number(_vm.fbaJob.destinationDistribution) === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("RailwayExport.TrackingNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "expressNo" },
                                model: {
                                  value: _vm.fbaJob.expressNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "expressNo", $$v)
                                  },
                                  expression: "fbaJob.expressNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("RailwayExport.POoriginalOrderNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "poNumber" },
                            model: {
                              value: _vm.fbaJob.poNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "poNumber", $$v)
                              },
                              expression: "fbaJob.poNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Shipment Id" } },
                        [
                          _c("el-input", {
                            attrs: { no: "shipmentId" },
                            model: {
                              value: _vm.fbaJob.shipmentId,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "shipmentId", $$v)
                              },
                              expression: "fbaJob.shipmentId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Reference Id" } },
                        [
                          _c("el-input", {
                            attrs: { no: "referenceId" },
                            model: {
                              value: _vm.fbaJob.referenceId,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "referenceId", $$v)
                              },
                              expression: "fbaJob.referenceId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("FbaJob.ChargingMethod")))]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              attrs: { no: "chargingMethod" },
                              on: { change: _vm.chargingMethodChange },
                              model: {
                                value: _vm.fbaJob.chargingMethod,
                                callback: function($$v) {
                                  _vm.$set(_vm.fbaJob, "chargingMethod", $$v)
                                },
                                expression: "fbaJob.chargingMethod"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v(_vm._s("KG"))
                              ]),
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v(_vm._s("CBM"))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("FbaChannel.bubbleCountingRatio")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "bubbleCountingRatio" },
                            on: { change: _vm.bubbleCountingChange },
                            model: {
                              value: _vm.fbaJob.bubbleCountingRatio,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "bubbleCountingRatio", $$v)
                              },
                              expression: "fbaJob.bubbleCountingRatio"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.pbProportion") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex", flex: "1" } },
                            [
                              _c("el-input", {
                                attrs: { no: "bubbleSplittingRatio" },
                                on: { change: _vm.bubbleSplittingRatioChange },
                                model: {
                                  value: _vm.fbaJob.bubbleSplittingRatio,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "bubbleSplittingRatio",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.bubbleSplittingRatio"
                                }
                              }),
                              _vm._v("% ")
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.CustomsDeclarationMethod"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPol",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 0 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPol
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPol = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.CustomsClearanceMethod"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPod",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 1 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPod
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPod = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("RailwayExport.EORIEnterpriseNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "eoriNo" },
                            model: {
                              value: _vm.fbaJob.eoriNo,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "eoriNo", $$v)
                              },
                              expression: "fbaJob.eoriNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("RailwayExport.VATtaxNumber") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "vatNo" },
                            model: {
                              value: _vm.fbaJob.vatNo,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "vatNo", $$v)
                              },
                              expression: "fbaJob.vatNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.VATRegistrationCountry"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "taxRegisterCountry",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Country,
                              filterable: "",
                              "callback-params": { key: "taxRegisterCountry" },
                              "callback-method-type": "value",
                              "default-value": _vm.fbaJob.taxRegisterCountry
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.taxRegisterCountry = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.VATRegistrationAddress"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "taxRegisterAddress" },
                            model: {
                              value: _vm.fbaJob.taxRegisterAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "taxRegisterAddress", $$v)
                              },
                              expression: "fbaJob.taxRegisterAddress"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("RailwayExport.VATCompanyEnglishName")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "taxCompany" },
                            model: {
                              value: _vm.fbaJob.taxCompany,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "taxCompany", $$v)
                              },
                              expression: "fbaJob.taxCompany"
                            }
                          })
                        ],
                        1
                      ),
                      _c("hr", {
                        staticStyle: {
                          "margin-top": "20px",
                          "margin-bottom": "20px"
                        }
                      }),
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.PODDeliveryInformation"))
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.DeliveryToWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.EstimatedDeliveryToWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estWarehouseDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estWarehouseDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estWarehouseDeliveryTime",
                                  $$v
                                )
                              },
                              expression: "form.estWarehouseDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.DeliveryToWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.ActualDeliveryToWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actWarehouseDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.actWarehouseDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "actWarehouseDeliveryTime",
                                  $$v
                                )
                              },
                              expression: "form.actWarehouseDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.EstimatedDeliveryToCustomersWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estGoodsDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estGoodsDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estGoodsDeliveryTime", $$v)
                              },
                              expression: "form.estGoodsDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.ActualDeliveryToCustomersWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actGoodsDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.actGoodsDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actGoodsDeliveryTime", $$v)
                              },
                              expression: "form.actGoodsDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("RailwayExport.EstimatedDeliveryTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estDeliveryTime", $$v)
                              },
                              expression: "form.estDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("RailwayExport.ActualDeliveryTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.actDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actDeliveryTime", $$v)
                              },
                              expression: "form.actDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.EstimatedReturnTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "45",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estReturnTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estReturnTime", $$v)
                              },
                              expression: "form.estReturnTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ActualReturnTime") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "46",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.actReturnTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actReturnTime", $$v)
                              },
                              expression: "form.actReturnTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.UserDefinedArea")))
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField1") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField1",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField1"),
                              _vm.form.userDefinedField1,
                              false,
                              function(val) {
                                _vm.form.userDefinedField1 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField1", $$v)
                          },
                          expression: "form.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField2") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField2",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField2"),
                              _vm.form.userDefinedField2,
                              false,
                              function(val) {
                                _vm.form.userDefinedField2 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField2", $$v)
                          },
                          expression: "form.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField3") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField3",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField3"),
                              _vm.form.userDefinedField3,
                              false,
                              function(val) {
                                _vm.form.userDefinedField3 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField3", $$v)
                          },
                          expression: "form.userDefinedField3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField4") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField4",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField3"),
                              _vm.form.userDefinedField4,
                              false,
                              function(val) {
                                _vm.form.userDefinedField4 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField4", $$v)
                          },
                          expression: "form.userDefinedField4"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "taxNature", $$v)
                            },
                            expression: "form.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.CustomerDeliveryInfo")))
            ]),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "row" } },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      position: "relative",
                      "margin-right": "10px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "50px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("char-count", {
                      attrs: { form: _vm.form, prefix: "shipper" }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                      [
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "175px"
                          },
                          attrs: {
                            no: "shipperId",
                            "method-params": { shipper: true, active: true },
                            "default-value": _vm.form.shipperId || ""
                          },
                          on: {
                            change: function(data) {
                              _vm.pm.shipperChange(data)
                            }
                          }
                        }),
                        _vm._v(" "),
                        !_vm.isFba
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "shipperBillAddress",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.billAddressDialog.visible = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.isFba
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "shipperBillAddress",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: { click: _vm.fbaCodeSearchBtn }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._l(7, function(i) {
                      return _c(
                        "el-form-item",
                        { key: i, attrs: { "label-width": "0" } },
                        [
                          _c("cargo-input", {
                            ref: "shipperLine" + i,
                            refInFor: true,
                            attrs: {
                              no: "shipperLine" + i,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "shipperLine" + i,
                                  i + 1 > 6 ? null : "shipperLine" + (i + 1),
                                  ""
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Shipper"),
                                  _vm.mergeShipperLine(),
                                  _vm.notUppercaseShipperConsigneNotify,
                                  _vm.splitShipperLine
                                )
                              }
                            },
                            model: {
                              value: _vm.form["shipperLine" + i],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine" + i, $$v)
                              },
                              expression: "form['shipperLine'+i]"
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      position: "relative",
                      "margin-right": "10px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "50px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("char-count", {
                      attrs: { form: _vm.form, prefix: "consignee" }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                      [
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "175px"
                          },
                          attrs: {
                            no: "consigneeId",
                            "method-params": { consignee: true, active: true },
                            "default-value": _vm.form.consigneeId || ""
                          },
                          on: {
                            change: function(data) {
                              _vm.pm.consigneeChange(data)
                            }
                          }
                        }),
                        _vm._v(" "),
                        !_vm.isFba
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "consigneeBillAddress",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.billAddressDialog.visible = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.isFba
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "consigneeBillAddress",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: { click: _vm.fbaCodeSearchBtn }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._l(7, function(i) {
                      return _c(
                        "el-form-item",
                        { key: i, attrs: { "label-width": "0" } },
                        [
                          _c("cargo-input", {
                            ref: "consigneeLine" + i,
                            refInFor: true,
                            attrs: {
                              no: "consigneeLine" + i,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "consigneeLine" + i,
                                  i + 1 > 6 ? null : "consigneeLine" + (i + 1),
                                  ""
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Consignee"),
                                  _vm.mergeConsigneeLine(),
                                  _vm.notUppercaseShipperConsigneNotify,
                                  _vm.splitConsigneeLine
                                )
                              }
                            },
                            model: {
                              value: _vm.form["consigneeLine" + i],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine" + i, $$v)
                              },
                              expression: "form['consigneeLine'+i]"
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      position: "relative",
                      "margin-right": "10px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "50px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("char-count", {
                      attrs: { form: _vm.form, prefix: "notify" }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                      [
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "175px"
                          },
                          attrs: {
                            no: "notifyId",
                            "method-params": { notify: true, active: true },
                            "default-value": _vm.form.notifyId || ""
                          },
                          on: {
                            change: function(data) {
                              _vm.pm.notifyChange(data)
                            }
                          }
                        }),
                        _vm._v(" "),
                        !_vm.isFba
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "noconifyBillAddress",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.billAddressDialog.visible = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.isFba
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "noconifyBillAddress",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: { click: _vm.fbaCodeSearchBtn }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._l(7, function(i) {
                      return _c(
                        "el-form-item",
                        { key: i, attrs: { "label-width": "0" } },
                        [
                          _c("cargo-input", {
                            ref: "notifyLine" + i,
                            refInFor: true,
                            attrs: {
                              no: "notifyLine" + i,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "notifyLine" + i,
                                  i + 1 > 6 ? null : "notifyLine" + (i + 1),
                                  ""
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.NotifyParty"),
                                  _vm.mergeNotifyLine(),
                                  _vm.notUppercaseShipperConsigneNotify,
                                  _vm.splitNotifyLine
                                )
                              }
                            },
                            model: {
                              value: _vm.form["notifyLine" + i],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine" + i, $$v)
                              },
                              expression: "form['notifyLine'+i]"
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "line-height": "28px",
                          "padding-bottom": "10px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.SecondNotifyParty")))]
                    ),
                    _c("cargo-rich-textarea", {
                      staticStyle: { width: "310px", height: "230px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "alsoNotify",
                        "text-chars": 0
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.SecondNotifyParty"),
                            _vm.form.alsoNotify,
                            _vm.notUppercaseShipperConsigneNotify,
                            function(val) {
                              _vm.form.alsoNotify = val
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.form.alsoNotify,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "alsoNotify", $$v)
                        },
                        expression: "form.alsoNotify"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "contact",
            visible: _vm.contactDialog.visible,
            title: _vm.$t("SeaExport.ContactPerson"),
            width: "400px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.contactDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactPerson") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.contactPerson,
                      no: "contactPerson"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Role") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.role,
                      no: "role"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.telephone,
                      no: "telephone"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Mobile") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.mobile,
                      no: "mobile"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Fax") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.fax,
                      no: "fax"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Email") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.email,
                      no: "email"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.remarks,
                      no: "remarks",
                      type: "textarea",
                      rows: 3
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceText",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "warning-count": -1,
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("hs-code-search-dialog", {
        attrs: {
          visible: _vm.hsCodeSearchDialog.visible,
          title: _vm.hsCodeSearchDialog.title,
          "hide-country-code": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.hsCodeSearchDialog, "visible", $event)
          },
          callback: _vm.hsCodeSearchDialog.successCallback
        }
      }),
      _c("select-operation-req-dialog", {
        attrs: {
          visible: _vm.selectOperationReqDialog.visible,
          lob: "RE",
          value: _vm.selectOperationReqDialog.value
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
          },
          callback: function(val) {
            _vm.form.operationContent = val
          }
        }
      }),
      _c("select-surcharge-terms-dialog", {
        attrs: {
          visible: _vm.selectSurchargeTermsDialog.visible,
          "job-uuid": _vm.form.uuid,
          "row-data": _vm.selectSurchargeTermsDialog.rowData,
          disabled: _vm.readonly
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectSurchargeTermsDialog, "visible", $event)
          },
          callback: _vm.handleSurchargeTerms
        }
      }),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("fba-bill-address-dialog", {
        attrs: { visible: _vm.fbaBillAddressDialog.visible, job: _vm.fbaJob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fbaBillAddressDialog, "visible", $event)
          },
          callback: _vm.fbaCodeSearchCallback
        }
      }),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }